import { SquarePen } from "lucide-react";
import React from "react";
import Badge from "../UI/Badge";

export default function NPIDatabaseDataTable(props) {
  const {
    tableData = [],
    dataLoading,
    setEditNpiData = () => {},
    setEditNpiModal = () => {},
    setPreviousScrollPosition = () => {},
  } = props;

  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th>Specialty</th>
              <th>NPI</th>
              <th>Practice & Provider Name</th>
              <th>Practice Address</th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    <td>
                      {item?.specialities?.map((element) => (
                        <Badge color="cyan" variant="docpro_fs_12">
                          {element.name}
                        </Badge>
                      ))}
                    </td>
                    <td>{item?.npi}</td>
                    <td>
                      <div className="docpro_table_info_list_lg">
                        <p className="docpro_mb_0">
                          <b>Practice: </b> {item?.provider_organization_name}
                        </p>
                        <p className="docpro_mb_0">
                          <b>Authorized: </b> {item?.authorized_official_first_name}{' '}
                          {item?.authorized_official_middle_name}{' '}
                          {item?.authorized_official_last_name}{' ('}
                          {item?.authorized_official_title_or_position}{')'}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className="docpro_table_info_list_lg">
                        {item?.provider_first_line_business_practice_location_address}, 
                        {item?.provider_business_practice_location_address_city_name}, 
                        {item?.provider_business_practice_location_address_state_name} 
                        {item?.provider_business_practice_location_address_postal_code?.slice(0, 6)}
                      </div>
                    </td>
                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns" phone={item?.provider_business_practice_location_address_telephone_number}>
                        <button 
                          className="docpro_icon_btn last_btn_tip"
                          onClick={() => {
                            setEditNpiData(item);
                            setEditNpiModal(true);
                            setPreviousScrollPosition(window.scrollY);
                            window.scrollTo(0, 0);
                          }}
                        >
                          <SquarePen width={18} height={18} />
                          <span className="docpro_tip">Edit Practice</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="5">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="5">
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
